import { defineSlotRecipe } from '@chakra-ui/react';

export const iconLabelSlotRecipe = defineSlotRecipe({
	defaultVariants: { variant: 'solid' },
	slots:           [ 'root', 'icon', 'label' ],

	base: {
		label: { textStyle: 'body' },

		icon: {
			height:  10,
			padding: 2,
			width:   10,
		},
		root: {
			alignItems: 'center',
			display:    'flex',
			gap:        2,
		},
	},
	variants: {
		iconStyle: { round: { icon: { borderRadius: 'full' } } },

		variant: {
			caption: {
				icon: {
					bg:      'transparent',
					color:   'gray.50',
					height:  4,
					padding: 0,
					width:   4,
				},
				label: {
					color:     'gray.50',
					textStyle: 'caption',
				},
			},
			featured: {
				icon: {
					bg:      'transparent',
					color:   'primary.100',
					height:  6,
					padding: 0,
					width:   6,
				},
				label: {
					color:     'text',
					textStyle: 'caption',
				},
			},
			solid: {
				icon: {
					bg:      'primary.100',
					color:   'white',
					height:  10,
					padding: 2,
					width:   10,
				},
			},
			subtle: {
				icon: {
					bg:      'primary.10',
					color:   'primary.100',
					height:  10,
					padding: 2,
					width:   10,
				},
			},
		},
	},
});
